import { CommonInsurerResponse } from '@/api/services/common/insurer/common-insurer.dto'
import axios from 'axios'

class CommonInsurerService {
    async findAllActiveInsurers(): Promise<CommonInsurerResponse> {
        const response = await axios.get<CommonInsurerResponse>(
            '/common/insurers/'
        )
        return response.data
    }
}

export const commonInsurerService = new CommonInsurerService()
